var checkScroll = function(el) {
    if (el[0]) {
        var topOfWindow = jQuery(window).scrollTop();
        var frozenBookmark = jQuery("#frozen-bookmark");
        const visibleArea =  jQuery("#datatable .datagrid").offset().top;
        frozenBookmark.html(el.clone());
        frozenBookmark.width(el.width() + 1);
        frozenBookmark.css({left: jQuery("#datatable .datagrid").offset().left - jQuery(window).scrollLeft()});
        frozenBookmark.toggle(topOfWindow > visibleArea);
    }
}

var sortFrozenHeader = function(el) {
    var obj = jQuery('#datatable #sortable-headers').children();
    obj[el.index()].click();
}

jQuery(window).on('scroll', function() { checkScroll(jQuery("#datatable .datagrid")) });
jQuery(document).on('click', "#frozen-bookmark #sortable-headers th", function() { sortFrozenHeader(jQuery(this)) });